<template>
  <div>
    <div class="toolsb">
      <el-input class="mb-input" placeholder="请输入考核名称" v-model="query.assesmentName"></el-input>

      <el-button type="primary" @click="toQuery">搜索</el-button>
      <el-button type="primary" @click="resetQuery">重置</el-button>
      <div class="custom">
        <el-radio-group v-model="query.assesmentCategory" @change="toQuery">
          <el-radio :label="0">线上</el-radio>
          <el-radio :label="1">线下</el-radio>
        </el-radio-group>
      </div>
      <div class="custom" v-on:click="myCourseTap">
        <img v-bind:src="isMyCourse ? myCourseCheckedIconTrue : myCourseCheckedIconFalse" alt="" />
        <span style="color: #333333">自建考核</span>
      </div>
      <el-button type="primary" @click="handleAdd">新增考核</el-button>
    </div>
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" :stripe="true" :header-cell-style="tableHeaderCellStyle">
      <el-table-column prop="assesmentId" label="编号" align="center" width="55"></el-table-column>
      <el-table-column prop="assesmentName" label="考核名称" align="center" width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="learnTopics.length" label="题目数量" align="center"></el-table-column>
      <el-table-column prop="assesmentScore" label="考核总分" align="center"></el-table-column>
      <el-table-column prop="passingScore" label="及格分数" align="center"></el-table-column>
      <el-table-column prop="sysUser.nickName" label="管理者" align="center" width="65"></el-table-column>
      <el-table-column prop="assesmentCategory" label="线上线下" align="center">
        <template slot-scope="scope">
          <span style="color: #3d6fd8" v-show="scope.row.assesmentCategory == 0">线上</span>
          <span style="color: #a11adb" v-show="scope.row.assesmentCategory == 1">线下</span>
        </template>
      </el-table-column>
      <el-table-column prop="assesmentAddress" label="线上地址" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="assesmentCategory" label="智能组卷" align="center">
        <template slot-scope="scope">
          <span style="color: #3d6fd8" v-show="scope.row.customerFlag == 0">否</span>
          <span style="color: #a11adb" v-show="scope.row.customerFlag == 1">是</span>
        </template>
      </el-table-column>
      <el-table-column prop="assesmentStartTime" label="开始时间" align="center" width="170"></el-table-column>
      <el-table-column prop="assesmentEndTime" label="结束时间" align="center" width="170"></el-table-column>
      <el-table-column align="center" label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button v-show="scope.row.assesmentCategory == 1" type="text" @click="handleOfflineScore(scope.$index, scope.row)">线下成绩录入</el-button>
          <el-button type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="mb-pagination" :current-page="curPage" layout="total, prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
  </div>
</template>

<script>
import paginationb from "@/mixins/paginationb";
export default {
  name: "AssessmentDepository",
  mixins: [paginationb],
  data () {
    return {
      addUrl: "",
      deleteUrl: "/learn/assesment/remove/",
      batchDeleteUrl: "/learn/assesment/batchRemove/ids",
      editUrl: "",
      queryUrl: "/learn/assesment/list",
      isMyCourse: false,
      myCourseCheckedIconFalse: require("@/assets/checked_false.png"),
      myCourseCheckedIconTrue: require("@/assets/checked_true.png")
    };
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo;
    }
  },
  mounted () {
    this.queryData();
  },
  methods: {
    /*
    * 自建课程
    * */
    myCourseTap () {
      this.isMyCourse = !this.isMyCourse;
      if (this.isMyCourse) {
        this.query.userId = this.userInfo.userId;
      } else {
        this.query.userId = "";
      }
      this.queryData();
    },
    handleAdd () {
      this.$router.push({
        path: "/ManageEducation/AssessmentDepositoryEdit",
        query: {
          assesmentId: null
        }
      });
    },
    handleDelete (index, row) {
      let that = this;
      let currentTime = new Date().getTime();
      let startTime = new Date(row.assesmentStartTime).getTime();
      let endTime = new Date(row.assesmentEndTime).getTime();
      if ((currentTime > startTime) && (currentTime < endTime)) {
        this.$message({
          type: "warning",
          message: "当前时间在开考时间内，不可删除"
        });
        return;
      }
      that.delteData(row.assesmentId);
    },
    handleEdit (index, row) {
      let that = this;
      let currentTime = new Date().getTime();
      let startTime = new Date(row.assesmentStartTime).getTime();
      let endTime = new Date(row.assesmentEndTime).getTime();
      if ((currentTime > startTime) && (currentTime < endTime)) {
        this.$message({
          type: "warning",
          message: "当前时间在开考时间内，不可修改"
        });
        return;
      }
      this.$router.push({
        path: "/ManageEducation/AssessmentDepositoryEdit",
        query: {
          assesmentId: row.assesmentId
        }
      });
    },
    handleOfflineScore (index, row) {
      this.$router.push({
        path: "/ManageEducation/OfflineScore",
        query: {
          assesmentId: row.assesmentId,
          classIdList: row.classIdList
        }
      });
    },
    handleCurrentChange (val) {
      this.curPage = val;
      this.queryData(this, val);
    }
  }
};
</script>

<style scoped lang="scss">
.custom {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px 10px;
}
</style>
